<template>
  <BaseCard
    :min-width="size"
    :min-height="block ? '96px' : size"
    :ripple="!disabled"
    :width="block ? '100%' : 'inherit'"
  >
    <input
      type="file"
      name="basePictureInput"
      id="basePictureInput"
      accept="image/jpeg,image/png,image/jpg"
      multiple
      ref="input"
      :disabled="disabled"
      @change="onPictureInputChange"
    />
    <label for="basePictureInput" class="basePictureInput__label">
      <BaseIcon
        :size="12"
        class="text--secondary mb-2"
        v-bind:class="{ 'text--disabled': disabled }"
        >fas fa-plus</BaseIcon
      >
      <span
        class="text--secondary text-caption font-weight-regular text-center"
        v-bind:class="{ 'text--disabled': disabled }"
      >
        Ajouter une photo <br />
        (max 10 MB)
      </span>
    </label>
  </BaseCard>
</template>

<script>
export default {
  name: "BasePictureInput",
  props: {
    block: {
      type: Boolean,
      default: () => false
    },
    disabled: {
      type: Boolean,
      default: () => false
    },
    maxPictureSize: {
      type: Number,
      default: () => false
    },
    size: {
      type: Number,
      default: () => 144
    }
  },
  data() {
    return {
      files: []
    };
  },
  methods: {
    onPictureInputChange(event) {
      if (event.target.files.length) {
        let pictures = [];
        for (let index = 0; index < event.target.files.length; index++) {
          const file = event.target.files[index];
          if (/.jpg$|.jpeg$|.png$/.test(file.type)) {
            if (this.maxPictureSize) {
              file.size <= this.maxPictureSize
                ? pictures.push(file)
                : this.$emit("pictureOverMaxSize", file.name);
            } else {
              pictures.push(file);
            }
          } else {
            this.$emit("fileIsNotAPicture", file.name);
          }
        }
        this.$emit("input", pictures);
        this.$refs.input.value = "";
      }
    }
  }
};
</script>

<style lang="scss" scoped>
#basePictureInput {
  display: none;
}
.basePictureInput__label {
  cursor: pointer;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 16px;
}
</style>
